import { Outlet, useNavigate } from "react-router-dom";
import { Sidebar } from "../components";
import "./BaseLayout.css";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { SidebarContext } from "../context/SidebarContext";
import { MdOutlineMenu } from "react-icons/md";
import { toast } from "react-toastify";
import { IoIosArrowDropdown, IoMdNotificationsOutline } from "react-icons/io";
import { IoIosArrowDropup } from "react-icons/io";
import {
  adminBalanceData,
  GetAllNotifications,
  GetReadNotifications,
  GetUnreadNotifications,
  refreshTokenApi,
  userBalanceData,
  GetAllActivities
} from "../config/LiveApi";
import { useSelector, useDispatch } from "react-redux";
import userSlice from "../redux/slices/userSlice";
import Card from "./Notification/Card";
import socket from "./../socket";
import axios from "axios";
import { useRefreshTokenTimer } from "../hooks/useRefreshTokenTimer";

const { actions } = userSlice;

const BaseLayout = () => {
  const remaining = useRefreshTokenTimer();
  // const [showTimerModal, setShowTimerModal] = useState(false);
  const [showExpiredModal, setShowExpiredModal] = useState(false);
  const [allnotifications, setAllNotifications] = useState([]);
  const [allActivities, setAllActivities] = useState([]);
  
  // const [readNotifications, setReadNotifications] = useState([]);
  const alertSound = useRef(new Audio("notification-sound.mp3"));
  // const alertSoundWebhookError = useRef(new Audio("notification-sound.mp3"));
  const [unreadCount, setUnreadCount] = useState(0);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showDrop, setshowDrop] = useState(false);
  const [balanceData, setBalanceData] = useState(0);
  const [availablePayout, setAvailablePayout] = useState(0);
  const navigate = useNavigate();
  const { openSidebar } = useContext(SidebarContext);
  const role = useSelector((store) => store.userReducer.role);
  const name = useSelector((store) => store.userReducer.userName);
  const token = useSelector((store) => store.userReducer.token);
  const dispatch = useDispatch();
  const notificationRef = useRef(null);

  // const hasExpiry = remaining > 0;

  // ✅ only show when valid AND within 5 min
  // const showTimer = hasExpiry && remaining <= 5 * 60 * 1000;

  // const minutes = Math.floor(remaining / 60000);
  // const seconds = Math.floor((remaining % 60000) / 1000);
  // const isCritical = hasExpiry && remaining <= 60 * 1000;

  // detect click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        setShowNotifications(false);
      }
    };

    if (showNotifications) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showNotifications]);

  const logout = () => {
    dispatch(actions.logout());
    navigate("/login");
    toast.success("Logged out successfully!");
  };
  const passwordChange = () => {
    navigate("/change-password");
    setshowDrop(false);
  };
  const userBalance = useCallback(async () => {
    if (token) {
      const resp = await userBalanceData(token);
      console.log(resp);
      setBalanceData(resp?.finalBalance);
      setAvailablePayout(resp?.walletBalance);
    }
  }, [token]);

  useEffect(() => {
    if (
      token &&
      (role === "admin" ||
        role === "operation" ||
        role === "mops" ||
        role === "subAdmin")
    ) {
      userBalance();
    }
  }, [role, token, userBalance]);

  useEffect(() => {
    const fetchInitialNotifications = async () => {
      const all = await GetAllNotifications(role);
      setAllNotifications(all);
    };
    if (role !== "admin" && role !== "subAdmin") {
      fetchInitialNotifications();
    }
  }, [role]);
  useEffect(() => {
    const fetchInitialActivities = async () => {
      const all = await GetAllActivities();
      setAllActivities(all);
    };
    if (role !== "admin" && role !== "subAdmin" && role !== "mops") {
      fetchInitialActivities();
    }
  }, [role]);
  useEffect(() => {
    if (role !== "admin" || role !== "mops" || role !== "subAdmin" || role !== "operation") {
      socket.on("notification", async (response) => {
        setAllNotifications((prev) => [response, ...prev]);
        //      if (response.type === "duplicate_webhook" && alertSound.current) {
        //   alertSound.current.play().catch(err => console.log("Sound play error:", err));
        // } else if (response.type === "error_webhook" && alertSoundWebhookError.current) {
        //   alertSoundWebhookError.current.play().catch(err => console.log("Sound play error:", err));
        // }
        // else{
        //   alertSound.current.play().catch(err => console.log("Sound play error:", err));
        // }

        if (showNotifications) {
          try {
            await axios.patch(`/notifications/${response._id}/read`);
            console.log("Notification marked as read:", response._id);
          } catch (err) {
            console.error("Failed to mark new notification as read", err);
          }
        } else {
          setUnreadCount((prev) => prev + 1);
        }
        if (alertSound.current) {
          alertSound.current
            .play()
            .catch((err) => console.log("Sound play error:", err));
        }
      });

      return () => {
        socket.off("notification");
      };
    }
  }, [showNotifications]);

  const toggleNotifications = async () => {
    const newState = !showNotifications;
    setShowNotifications(newState);

    if (!newState) return; // Only act when opening
    // const unread = allnotifications.filter((n) => !n.read);
    try {
      // await Promise.all(
      //   unread.map((n) =>
      //     axios.patch(`/notifications/${n._id}/read`)
      //   )
      // );
      const updated = allnotifications.map((n) =>
        !n.read ? { ...n, read: true } : n,
      );
      setAllNotifications(updated);
      setUnreadCount(0);
    } catch (error) {
      console.error("Failed to mark all as read:", error);
    }
  };
  const handleAutoLogout = useCallback(() => {
    dispatch(actions.logout());
    navigate("/login");
    toast.error("Session expired. Please log in again.");
  }, [dispatch, navigate]);
  // const handleRefreshSession = async () => {
  //   try {
  //     if (showTimer) {
  //       toast.success("Session extended successfully.", { autoClose: 1000 });
  //       setShowTimerModal(false);
  //     }
  //     const refreshToken = store.getState().userReducer.refreshToken;

  //     const res = await refreshTokenApi(refreshToken);

  //     store.dispatch(actions.setItem(["token", res.accessToken]));

  //     if (res.refreshToken) {
  //       store.dispatch(actions.setItem(["refreshToken", res.refreshToken]));
  //     }

  //     const newExpiryTimestamp = Date.now() + Number(res.refreshTokenExpiry);
  //     store.dispatch(
  //       actions.setItem(["refreshTokenExpiry", newExpiryTimestamp])
  //     );

  //     return res.accessToken;
  //   } catch (error) {
  //     store.dispatch(actions.logout());
  //     window.location.href = "/login";
  //     throw error;
  //   }
  // };
  // useEffect(() => {
  //   if (showTimer) {
  //     setShowTimerModal(true);
  //   }
  // }, [showTimer]);

  useEffect(() => {
    if (remaining <= 0 && remaining !== null) {
      // setShowTimerModal(false);
      setShowExpiredModal(true);
    }
  }, [remaining]);

  return (
    <main
      className="page-wrapper main-back-pope"
      onClick={() => (showDrop ? setshowDrop(false) : "")}
    >
      <Sidebar allActivities={allActivities} />
      <div className="nav-main">
        <div className="size-main-nav">
          <div className="user-name">
            <button
              className="sidebar-open-btn-1"
              type="button"
              onClick={openSidebar}
            >
              <MdOutlineMenu size={24} />
            </button>

            <div className="right-hand">
              {(role === "admin" || role === "mops" || role === "subAdmin") && (
                <div className="merch-wallet-balance">
                  Wallet Balance: <span>₹ {availablePayout?.toFixed(2)}</span>
                </div>
              )}
              {(role === "admin" || role === "subAdmin") && (
                <div className="bal-tag">
                  Ledger Balance: <span>₹ {balanceData?.toFixed(2)}</span>
                </div>
              )}
              {(role === "super" || role === "operation") && (
                <div
                  className={`notification-icon ${showNotifications ? "active-notification" : ""}`}
                  ref={notificationRef}
                >
                  <div
                    className="notification-icon-inner"
                    onClick={toggleNotifications}
                  >
                    <IoMdNotificationsOutline size={22} className="notification-badge"/>
                    {allnotifications.length > 0 && (
                      <span className="notification-badge">
                        {allnotifications.length >= 11
                          ? "10+"
                          : allnotifications.length}
                      </span>
                    )}
                  </div>
                  {showNotifications && (
                    <Card
                      showNotifications={showNotifications}
                      setShowNotifications={setShowNotifications}
                      setAllNotifications={setAllNotifications}
                      allnotifications={allnotifications}
                    />
                  )}
                </div>
              )}

              <div>
                <p
                  onClick={() => setshowDrop(!showDrop)}
                  className="align-name"
                >
                  {name || "User Name"}
                  {showDrop ? (
                    <IoIosArrowDropup
                      style={{ width: "1.2rem", height: "1.2rem" }}
                    />
                  ) : (
                    <IoIosArrowDropdown
                      style={{ width: "1.2rem", height: "1.2rem" }}
                    />
                  )}
                </p>
                {showDrop && (
                  <div className="userdropdown">
                    <p onClick={passwordChange}>Change Password</p>
                    <p onClick={logout}>Logout</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* {showTimerModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backdropFilter: "blur(10px)",
            background: "rgba(0,0,0,0.4)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "white",
              padding: "28px",
              borderRadius: "14px",
              width: "420px",
              maxWidth: "90%",
              textAlign: "center",
              boxShadow: "0 10px 40px rgba(0,0,0,0.25)",
            }}
          >
            <h2
              style={{
                marginBottom: "10px",
                fontSize: "22px",
                fontWeight: "700",
                color: "#dc3545",
              }}
            >
              Session Expiring Soon
            </h2>

            <p
              style={{
                fontSize: "14px",
                color: "#555",
                marginBottom: "18px",
              }}
            >
              Your session is about to expire. Please extend your session to
              continue without interruption.
            </p>

            <div
              style={{
                background: "#f8d7da",
                color: "#721c24",
                padding: "14px",
                borderRadius: "10px",
                fontSize: "20px",
                fontWeight: "600",
                marginBottom: "20px",
              }}
            >
              {minutes}:{seconds.toString().padStart(2, "0")}
            </div>

            <p
              style={{
                fontSize: "12px",
                color: "#888",
                marginBottom: "20px",
              }}
            >
              If not extended, you will be automatically logged out.
            </p>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "12px",
              }}
            >
              <button
                onClick={handleRefreshSession}
                style={{
                  background: "#dc3545",
                  color: "white",
                  border: "none",
                  padding: "8px 16px",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontWeight: "600",
                }}
              >
                Extend Session
              </button>

              <button
                onClick={() => setShowTimerModal(false)}
                style={{
                  background: "#6c757d",
                  color: "white",
                  border: "none",
                  padding: "8px 16px",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontWeight: "600",
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )} */}
      {showExpiredModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backdropFilter: "blur(12px)",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10000,
          }}
        >
          <div
            style={{
              background: "white",
              padding: "30px",
              borderRadius: "14px",
              width: "400px",
              maxWidth: "90%",
              textAlign: "center",
              boxShadow: "0 10px 40px rgba(0,0,0,0.3)",
            }}
          >
            {/* 🔴 Title */}
            <h2
              style={{
                color: "#dc3545",
                marginBottom: "12px",
                fontSize: "22px",
                fontWeight: "700",
              }}
            >
              ❌ Session Expired
            </h2>

            {/* 📝 Message */}
            <p
              style={{
                color: "#555",
                fontSize: "14px",
                marginBottom: "20px",
              }}
            >
              Your session has expired. Please log in again to continue.
            </p>

            {/* 🔘 Button */}
            <button
              onClick={() => {
                setShowExpiredModal(false);
                handleAutoLogout();
              }}
              style={{
                background: "#dc3545",
                color: "white",
                border: "none",
                padding: "10px 18px",
                borderRadius: "6px",
                cursor: "pointer",
                fontWeight: "600",
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}
      <div className="content-wrapper">
        <Outlet />
      </div>
    </main>
  );
};

export default BaseLayout;
